import type { CSSProperties } from 'react';
import type { Icon as PhosphorIconType, IconWeight } from '@phosphor-icons/react';
import { Link } from '../../lib/routing';

import { Icon, type IconName } from './icons';
import { covers } from './rail-active';

export type RailIcon = IconName | PhosphorIconType;

/* Le plein marque un ETAT, pas une identite : l entree courante est pleine, les
   autres au trait. Si toutes les icones sont pleines, aucune n attire l oeil —
   c est le contraste de graisse qui designe, pas la graisse elle-meme. */
function RailGlyph({ icon, weight }: { icon: RailIcon; weight: IconWeight }) {
  if (typeof icon === 'string') return <Icon name={icon} weight={weight} />;
  const Glyph = icon;
  return <Glyph size={20} weight={weight} />;
}

/* Rail navigation item, extracted from Header.tsx (decomposition, Phase 4). */

/*
 * `active` est calculé À L'ÉCHELLE DU RAIL (voir `rail-active.ts`) et injecté
 * ici : la réponse dépend des entrées voisines, qu'une entrée isolée ne connaît
 * pas. Le repli local ne sert qu'aux usages hors rail.
 */
export function SideItem({
  to,
  icon,
  current,
  accent,
  active,
  onNav,
  children,
}: {
  to: string;
  icon: RailIcon;
  current: string;
  accent?: string;
  active?: boolean;
  onNav?: () => void;
  children: string;
}) {
  const isActive = active ?? covers(to, current);
  const accentStyle = accent ? ({ '--sideitem-accent': accent } as CSSProperties) : undefined;
  return (
    <Link
      to={to}
      className="naia-item naia-sideitem"
      onClick={onNav}
      aria-label={children}
      title={children}
      aria-current={isActive ? 'page' : undefined}
      style={accentStyle}
    >
      <span aria-hidden className="naia-item__icon is-w22">
        <RailGlyph icon={icon} weight={isActive ? 'fill' : 'regular'} />
      </span>
      <span className="naia-rail__label">{children}</span>
    </Link>
  );
}
